import { intervalToDuration, formatDuration } from 'date-fns';
import i18next from 'i18next';

// eslint-disable-next-line import-x/no-unresolved, import-x/extensions -- .ts resolves at build; eslint TS-resolver flaky here
import { getDateFnsLocale } from './dateFnsLocale';

//  'xDays' | 'xHours' | 'xMinutes' | 'xSeconds' - зарезервированные в 'date-fns' названия токенов.
//  Ключи соответствуют полю code локали 'date-fns' (en-US, ru, pt-BR, es).
//  ru/pt/es под guard'ами локалей, чтобы их строки не попадали в бандл отключённых локалей.
const formatDistanceLocale = {
  'en-US': {
    xDays: '{{count}} day',
    xHours: '{{count}} hour',
    xMinutes: '{{count}} minute',
    xSeconds: '{{count}} second',
  },
  ...(__LOCALE_RU__ ? {
    ru: {
      xDays: '{{count}} день',
      xHours: '{{count}} час',
      xMinutes: '{{count}} минута',
      xSeconds: '{{count}} секунда',
    },
  } : {}),
  ...(__LOCALE_PTBR__ ? {
    'pt-BR': {
      xDays: '{{count}} dia',
      xHours: '{{count}} hora',
      xMinutes: '{{count}} minuto',
      xSeconds: '{{count}} segundo',
    },
  } : {}),
  ...(__LOCALE_ESES__ ? {
    es: {
      xDays: '{{count}} día',
      xHours: '{{count}} hora',
      xMinutes: '{{count}} minuto',
      xSeconds: '{{count}} segundo',
    },
  } : {}),
};

export const getTimeOffset = (timeOffset, startTime = 0) => {
  if (typeof startTime !== 'number' || typeof timeOffset !== 'number' || Number.isNaN(startTime) || Number.isNaN(timeOffset)) {
    console.error('getTimeOffset: invalid input data');
    return;
  }

  const currentLocale = getDateFnsLocale(i18next.language);

  const timeInterval = intervalToDuration({ start: new Date(startTime * 1000), end: new Date(timeOffset * 1000) });
  const customLocale = {
    /*
    formatDistance - зарезервированная в библиотеке 'date-fns' функция c аргументами для метода formatDuration,
    внутри которой можно писать свою логику
    */
    formatDistance: (token, count) => formatDistanceLocale[currentLocale.code][token].replace('{{count}}', count),
  };

  // eslint-disable-next-line consistent-return
  return formatDuration({
    days: timeInterval.days,
    hours: timeInterval.hours,
    minutes: timeInterval.minutes,
    seconds: timeInterval.seconds,
  }, { locale: customLocale });
};
